const addToCartButton = document.querySelector("#product__info-wrapper #addToCartForm");
const sbmtBtn = document.querySelector("#product__info-wrapper #product-form-submit-btn");
const variantButton = document.querySelector(".product__info-container #variant-selector-form");
const titleBlock = document.getElementById("product-title-block");
const titleFont = document.getElementById("product-title");
const priceFont = document.getElementById("price-regular-fonts");
const cookieBtn = document.getElementById("ot-sdk-btn-floating");
const klaviyoBtn = document.getElementById("klaviyo-btn");
const errorMsg = document.getElementById("error-msg-pdp");

let offsetHeight = document.getElementById('product__info-wrapper').offsetHeight;

const sticky = addToCartButton.offsetTop;
var w = document.documentElement.clientWidth || window.innerWidth;

function stickyButton() {

  if (w <= 750) {
    document.getElementById('product__info-wrapper').style.height = offsetHeight + "px";
    let chatButton = document.querySelector("div.helpButton");

    if(window.pageYOffset >= sticky && !((window.innerHeight + Math.round(window.scrollY)) >= (document.body.offsetHeight))){
      if(chatButton){
        chatButton.style.bottom = 'calc(100px + ' + titleBlock.offsetHeight + 'px)';
      }
      offsetHeight = document.getElementById('product__info-wrapper').offsetHeight;
      errorMsg.classList.add("error-msg-sticky-mobile");
      addToCartButton.classList.add("sticky-buttonAddToCart-mobile");
      variantButton.classList.add("sticky-variantSelector-mobile");
      titleBlock.classList.add("sticky-titleBlock-mobile");
      titleFont.classList.add("productTitleFontMobile-sticky");
      //priceFont.classList.add("productPriceFontMobile-sticky");
      sbmtBtn.classList.add("sticky-sbmtBtn-mobile");
      klaviyoBtn.classList.add("sticky-sbmtBtn-mobile");
      //document.getElementById("ot-sdk-btn-floating").style.bottom = "140px";
      //document.getElementById("szb-container").style.display = "none";
  } else if((window.innerHeight + Math.round(window.scrollY)) == (document.body.offsetHeight)) {
    document.getElementById('product__info-wrapper').style.height = offsetHeight + "px";
    errorMsg.classList.remove("error-msg-sticky-mobile");
    addToCartButton.classList.remove("sticky-buttonAddToCart-mobile");
    variantButton.classList.remove("sticky-variantSelector-mobile");
    titleBlock.classList.remove("sticky-titleBlock-mobile");
    titleFont.classList.remove("productTitleFontMobile-sticky");
    //priceFont.classList.remove("productPriceFontMobile-sticky");
    sbmtBtn.classList.remove("sticky-sbmtBtn-mobile");
    klaviyoBtn.classList.remove("sticky-sbmtBtn-mobile");
    //document.getElementById("ot-sdk-btn-floating").style.bottom = "10px";
    addToCartButton.classList.add("remove-sticky");
    variantButton.classList.add("remove-sticky");
    titleBlock.classList.add("remove-sticky");
    sbmtBtn.classList.add("remove-sticky");
    klaviyoBtn.classList.add("remove-sticky");
      if(chatButton){
        chatButton.style.bottom = '0px';
      }
  }else{
    document.getElementById('product__info-wrapper').style.height ="auto";
    errorMsg.classList.remove("error-msg-sticky-mobile");
    addToCartButton.classList.remove("sticky-buttonAddToCart-mobile");
    variantButton.classList.remove("sticky-variantSelector-mobile");
    titleBlock.classList.remove("sticky-titleBlock-mobile");
    titleFont.classList.remove("productTitleFontMobile-sticky");
    //priceFont.classList.remove("productPriceFontMobile-sticky");
    sbmtBtn.classList.remove("sticky-sbmtBtn-mobile");
    klaviyoBtn.classList.remove("sticky-sbmtBtn-mobile");
    //document.getElementById("ot-sdk-btn-floating").style.bottom = "10px";
    //document.getElementById("szb-container").style.display = "block";
    addToCartButton.classList.add("remove-sticky");
    variantButton.classList.add("remove-sticky");
    titleBlock.classList.add("remove-sticky");
    sbmtBtn.classList.add("remove-sticky");
    klaviyoBtn.classList.add("remove-sticky");
      if(chatButton){
       chatButton.style.bottom = '0px'; 
      }
  }
  }
}

document.addEventListener("scroll", (event) => {
  offsetHeight = document.getElementById('product__info-wrapper').offsetHeight;
  stickyButton();
});

const stickyMenuElements = [addToCartButton, variantButton, titleBlock];
const productRecommendationSections = document.querySelectorAll('[class*="product-recommendations-section-"]');

function hideStickyMenuElements() {
  for (const observedElement of stickyMenuElements)
    observedElement.classList.add("hidden");
}

function showStickyMenuElements() {
  for (const observedElement of stickyMenuElements)
    observedElement.classList.remove("hidden");
}

if (productRecommendationSections && stickyMenuElements) {
  const bottomOffsetHeight = 140; // calculated height in px of sticky "add to cart" form
  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      const isInViewport = entry.isIntersecting;
      if (!isInViewport) {
        showStickyMenuElements();
        continue;
      }

      const spaceFromBottom = window.innerHeight - entry.boundingClientRect.bottom;
      if (bottomOffsetHeight >= spaceFromBottom) hideStickyMenuElements();
      else showStickyMenuElements();
    }
  }, {
    threshold: [0, 0.05, 0.1, 0.25, 0.5, 0.75, 0.9, 0.95, 1]
  });
  for (const productRecommendationSection of productRecommendationSections)
    observer.observe(productRecommendationSection);
}
